import { render } from "./TodoList.vue?vue&type=template&id=7a9c4c1a&scoped=true&ts=true"
import script from "./TodoList.vue?vue&type=script&lang=ts"
export * from "./TodoList.vue?vue&type=script&lang=ts"

import "./TodoList.vue?vue&type=style&index=0&id=7a9c4c1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9c4c1a"]])

export default __exports__